export enum CurrencyCents {
  Rp = 0,
  Cents = 1,
}
